import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShiftSettingEntity } from '../../domain/entities/ShiftSettingEntity'
import { ShiftSettingRegionModel } from './ShiftSettingRegionModel'
export class ShiftSettingModel extends ShiftSettingEntity {
  constructor(dataDto: ShiftSettingModel) {
    const shiftSettingRegionModel = dataDto.shiftSettingRegions?.map(
      (region) => new ShiftSettingRegionModel(region)
    )
    super()
    mapEntityProperties<ShiftSettingEntity>(this, dataDto, {
      map: {
        shiftSettingRegions: shiftSettingRegionModel
      }
    })
  }
}
